import { ReactNode } from 'react';
import { RBACDataProvider } from './rbac-data-context';
import { RBACPermissionsProvider } from './rbac-permissions-context';

// Props for the combined provider
interface RBACProviderProps {
  children: ReactNode;
}

/**
 * Enhanced RBACProvider that combines data and permissions contexts
 * Split into two separate providers for better performance and caching
 */
export const RBACProvider = ({ children }: RBACProviderProps) => {
  return (
    <RBACPermissionsProvider>
      <RBACDataProvider>
        {children}
      </RBACDataProvider>
    </RBACPermissionsProvider>
  );
}; 